var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "filter_alt_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_43328",
    "data-name": "Path 43328",
    d: "M0,0H36m0,36H0",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43329",
    "data-name": "Path 43329",
    d: "M8.606,7.083H24.03L16.3,16.8Zm-4.241-.6c3.116,3.993,8.869,11.393,8.869,11.393v9.25a1.547,1.547,0,0,0,1.542,1.542H17.86A1.547,1.547,0,0,0,19.4,27.125v-9.25s5.738-7.4,8.853-11.393A1.538,1.538,0,0,0,27.037,4H5.583A1.538,1.538,0,0,0,4.365,6.482Z",
    transform: "translate(1.683 1.667)",
    fill: "#9e9e9e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43330",
    "data-name": "Path 43330",
    d: "M0,0H36V36H0Z",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.29ee7b8e52d0075bdb937b2356a00549.svg";
export { ForwardRef as ReactComponent };